export default __webpack_public_path__ + "static/media/close.011516a2.svg";